// Konvertierung zwischen <input type="datetime-local"> (lokale Zeit) und UTC-ISO.

// Lokaler Eingabewert 'YYYY-MM-DDTHH:mm' -> UTC-ISO ('...Z'); leer -> null
export function localToIso(localValue) {
  if (!localValue) return null;
  const d = new Date(localValue); // wird als lokale Zeit interpretiert
  if (isNaN(d.getTime())) return null;
  return d.toISOString();
}

// UTC-ISO -> lokaler Eingabewert 'YYYY-MM-DDTHH:mm' für datetime-local
export function isoToLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
    d.getMinutes()
  )}`;
}
